import React from "react";
import { removeAllSpaces } from "../../utils";
import styles from "./styles.module.css";
import { sentenceCase } from "../../constants";
// displayLabel: optional translated text to show; `label` stays the value passed to onChange
const UBRadioBox = ({ label, displayLabel, value, onChange, key, disabled, checked=false,isLabelStatic = false }) => {
  return (
    <div
      key={key}
      className={`${styles.filterRadioOptionItem} ${disabled && styles.disabledRadioBtn}} filterRadioOptionItem`}
      onClick={() => (label && !disabled ? onChange(label) : {})}
    >
      <label
        className={`${styles.radioOption} radioOption`}
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey)
            return label && !disabled ? onChange(label) : {};
        }}
      >
        {displayLabel ? displayLabel : isLabelStatic ? label : sentenceCase(label)}
        <input
          tabIndex={-1}
          type="radio"
          label={label}
          disabled={disabled}
          id={`${removeAllSpaces(label)}_optId`}
          checked={checked || label === value}
        />
        {!!label && <span className={`${styles.checkmark} checkmark`} />}
      </label>
    </div>
  );
};

export default UBRadioBox;
